import EmptyState from "ds/components/EmptyState";
import Button from "ds/components/Button";
import Box from "ds/components/Box";
import { EmptystatePuzzleColored } from "components/icons/generated";

import { showCreateIntentProjectDrawer } from "./CreateIntentProjectDrawer";

type IntentProjectsEmptyProps = {
  hasNoSearchResult?: boolean;
};

const IntentProjectsEmpty = ({ hasNoSearchResult }: IntentProjectsEmptyProps) => {
  return hasNoSearchResult ? (
    <EmptyState
      title="No results"
      caption={`Don’t give up! Check the spelling or try something less specific.`}
      icon={EmptystatePuzzleColored}
    />
  ) : (
    <EmptyState
      title="No Intent Projects yet"
      caption="Intent Projects are secure execution environments for MCP tools with cloud integration credentials."
      icon={EmptystatePuzzleColored}
    >
      <Box gap="medium">
        <Button variant="primary" onPress={() => showCreateIntentProjectDrawer()}>
          Create your first Intent Project
        </Button>
      </Box>
    </EmptyState>
  );
};

export default IntentProjectsEmpty;
